<!-- <script src="https://js.stripe.com/v3/"></script> -->
<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<app-layout-box></app-layout-box>